import { Tree, TreeNode } from "@/types/tree";
import { getPromptInfoFromNode } from "../util";
import { saveToElementMetadata } from "@/lib/ai/ai";
import { documentStore } from "@/store/store";

export type PageSection = {
  nodeId: TreeNode["id"];
  description: string;
  title: string;
};

export function getPageStructureFromTree(tree: Tree) {
  return tree.root.children.map(getPageSectionFromNode);
}

export function getPageSectionFromNode(node: TreeNode): PageSection {
  const promptInfo = getPromptInfoFromNode(node);

  return {
    nodeId: node.id,
    title: node.data.properties?.meta?.friendlyName?.trim() || promptInfo.singularity.sectionData.type || "unknown",
    description: promptInfo.sectionDescription || "unknown"
  };
}

export function updateSectionDescription(
  sectionId: TreeNode["id"],
  description: string
) {
  documentStore.unthrottledPropertyChanged({
    elementId: sectionId,
    path: "meta.promptInfo.sectionDescription",
    meta: {
      snapshotLabel: `Updated sectionDescription for "${sectionId}"`
    },
    value: description
  });
}

export function updateSectionFriendlyName(
  sectionId: TreeNode["id"],
  friendlyName: string
) {
  documentStore.unthrottledPropertyChanged({
    elementId: sectionId,
    path: "meta.friendlyName",
    meta: {
      snapshotLabel: `Updated friendly name for element "${sectionId}"`
    },
    value: friendlyName.trim()
  });
}
